module.exports = __webpack_public_path__ + "img/dver.7edf7ed9.svg";